import { useCallback } from 'react'
import { setOnboardingLoaderVisible } from 'redux/actions'
import { useDispatch } from 'react-redux'

export const useOnboardingLoader = () => {
  const dispatch = useDispatch()

  const hideOnboardingLoader = useCallback(() => {
    dispatch(setOnboardingLoaderVisible(false))
  }, [dispatch])

  const showOnboardingLoader = useCallback(
    ({ timeout, onTimeout }: { timeout?: number; onTimeout?: () => void } = {}) => {
      dispatch(setOnboardingLoaderVisible(true))
      if (timeout)
        setTimeout(() => {
          hideOnboardingLoader()
          onTimeout?.()
        }, timeout)
    },
    [dispatch, hideOnboardingLoader],
  )

  const hideOnboardingLoaderAfterTimeout = useCallback(
    (timeout: number = 2900) => {
      setTimeout(hideOnboardingLoader, timeout)
    },
    [hideOnboardingLoader],
  )

  return {
    showOnboardingLoader,
    hideOnboardingLoader,
    hideOnboardingLoaderAfterTimeout,
  }
}
